export default __webpack_public_path__ + "static/media/arrow-down-dark.b055c023.svg";